<template>
    <Wrapper :title="$t('revoke.accountRevoke')" @on-back="$emit('on-back', $options.name)">
        <template #content>
            <h2 class="text-base mb-24">{{ $t('revoke.hesitation') }}</h2>
            <i18n path="revoke.hesitationText0" tag="p" class="indent-2">
                <span place="days" style="color: #ff4d4f">
                    {{ initialRevoke.hesitationDuration }}
                </span>
            </i18n>
            <br />
            <p class="indent-2">{{ $t('revoke.hesitationText1') }}</p>
            <br />
            <p class="indent-2">{{ $t('revoke.hesitationText2') }}</p>
        </template>
        <template #footer>
            <van-button
                class="w-full"
                type="info"
                :disabled="disabled"
                :loading="loading"
                @click="handleClick"
            >
                {{ $t('revoke.hesitationConfirm', { second: count ? count + ' s' : '' }) }}
            </van-button>
            <van-button v-if="showCancel" class="w-full cancel" @click="handleAbort">
                {{ $t('common.cancel') }}
            </van-button>
        </template>
    </Wrapper>
</template>

<script>
import Vue from 'vue';
import { Button } from 'vant';
import useCountdown from '@/mixins/useCountdown';
import { hesitate } from '@/api/revoke';
import { isGray } from '@/lib/axios/config';
import { Platform } from '@/enums';
import Wrapper from './Wrapper.vue';
import { Target } from '../constant';

Vue.use(Button);

export default {
    name: 'Hesitation',
    mixins: [useCountdown],
    components: {
        Wrapper,
    },
    props: {
        initialRevoke: {
            type: Object,
            required: true,
        },
        captchaData: {
            type: Object,
            required: true,
        },
        platform: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    mounted() {
        const time = isGray ? 2 : 15;
        this.countdown(time, time);
    },
    computed: {
        showCancel() {
            return ![Platform.H5, Platform.Iframe].includes(this.platform);
        },
    },
    methods: {
        handleAbort() {
            const data = JSON.stringify({ data: { action: -2 }, msg: 'User canceled.', code: -2 });
            try {
                if (this.platform === Platform.WebView) {
                    window.RevokeCallback(data);
                } else if (this.platform === Platform.Android) {
                    window.logoffJsBridge.RevokeCallback(data);
                }
            } catch (e) {
                console.log(e);
            }
        },
        async handleClick() {
            try {
                this.loading = true;
                const data = await hesitate(this.captchaData.flowId);
                this.$emit('on-step', {
                    current: Target.Hesitation,
                    target: Target.SuccessWithHesitate,
                    data,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.cancel {
    margin-top: 12px;
    background-color: #646566;
    border-color: #646566;
    color: #fff;
}

.apple-logo {
    width: auto;
    height: 20px;
    vertical-align: text-bottom;
}
</style>
